import Link from "next/link";
import router, { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Logo } from "@/components/ui/Logo";
import { Stack } from "common/ui/Stack";

import store from "common/middleware/store";
import { useLoggedInUser } from "common/middleware/hooks";
import { logout } from "common/middleware/api.auth";

import styles from "./Layout.module.scss";

interface Props {
  children: React.ReactNode,
}

export function Layout({ children }: Props) {
  const { locale, pathname, query } = useRouter();
  const { t } = useTranslation("auth");
  const { user } = useLoggedInUser();

  return (
    <div className={styles.Layout}>
      <header className={styles.Header}>
        <Logo type="light" width={120} />
        <Stack gap={32} alignItems="center">
          <Link
            className={styles.LocaleBtn}
            locale={locale === "en-US" ? "fr" : "en-US"}
            href={{ pathname, query }}
          >
            {t("locale")}
          </Link>
          {user && (
            <button
              className={styles.LogoutBtn}
              onClick={() => {
                router.push("/login");
                logout();
                store.isSigningOut = false;
              }}
            >
              {t("signOut")}
            </button>
          )}
        </Stack>
      </header>
      <main className={styles.Content}>
        {children}
      </main>
    </div>
  )
}
